import React, { useContext } from 'react';
import { Button, Icon, Input, message, Typography } from 'antd';
import cn from 'classnames';
import {
  useStateMethods,
  useStateSelector,
} from '../../../providers/stateManager';
import {
  selectCommentText,
  selectIsTextValid,
  selectTextLimitExceeded,
  selectTextSize,
} from '../../../utils/selectors';
import { stateKeys } from '../../../constants/stateKeys';
import { FILE_SIZE, TEXT_SIZE } from '../../../constants/limits';
import { useLoading, useSubmitContext } from '../providers';
import styles from './index.module.scss';

const Form = () => {
  const loading = useLoading();

  return (
    <form className={styles.root}>
      <div className={styles.fieldsWrapper}>
        <Fields loading={loading} />
      </div>
      <SubmitBtn loading={loading} />
    </form>
  );
};

export default Form;

function Fields({ loading }) {
  const limitExceeded = useStateSelector(selectTextLimitExceeded);

  return (
    <div className={styles.fieldsWrapper}>
      <div className={cn(styles.field, { [styles.error]: limitExceeded })}>
        <TextArea loading={loading} />
        <Upload loading={loading} />
      </div>
      <Counter limitExceeded={limitExceeded} />
    </div>
  );
}

function TextArea({ loading }) {
  const value = useStateSelector(selectCommentText);

  const { setValue } = useStateMethods();

  const handleChange = (e) => {
    setValue(stateKeys.text, e.target.value);
  };

  return (
    <Input.TextArea
      autoFocus
      value={value ?? ''}
      onChange={handleChange}
      className={styles.textArea}
      placeholder="Сообщение"
      autoSize={{ minRows: 1, maxRows: 4 }}
      disabled={loading}
    />
  );
}

function Upload({ loading }) {
  const { setState } = useStateMethods();

  const handleLabelClick = (e) => {
    e.stopPropagation();
  };

  const handleChange = (event) => {
    const attachments = event.target.files;

    const files = [];
    const images = [];

    for (let attachment of attachments) {
      if (attachment.size > FILE_SIZE) {
        message.error('Размер прикрепляемого файла не должен превышать 15 MB.');
        return;
      }

      const collection = attachment.type.startsWith('image') ? images : files;
      collection.push(attachment);
    }

    setState((prev) => {
      const prevFiles = prev[stateKeys.files];
      const prevImages = prev[stateKeys.images];

      return {
        [stateKeys.files]: files.length ? [...prevFiles, ...files] : prevFiles,
        [stateKeys.images]: images.length
          ? [...prevImages, ...images]
          : prevImages,
      };
    });
  };

  return (
    <label className={styles.upload} onClick={handleLabelClick}>
      <input
        multiple
        className={styles.attachFilesInput}
        type="file"
        onChange={handleChange}
        disabled={loading}
      />
      <Icon type="paper-clip" />
    </label>
  );
}

function SubmitBtn({ loading }) {
  const valid = useStateSelector(selectIsTextValid);

  const submitContext = useSubmitContext();

  const onSubmit = useContext(submitContext);

  return (
    <Button
      disabled={!valid || loading}
      type="primary"
      loading={loading}
      shape="circle"
      icon="arrow-up"
      style={loading ? { background: '#7aabff' } : null}
      className={styles.submitBtn}
      onClick={onSubmit}
    />
  );
}

function Counter({ limitExceeded }) {
  const currentTextSize = useStateSelector(selectTextSize);

  return (
    <Typography.Text
      className={cn(styles.counter, { [styles.error]: limitExceeded })}
    >
      {currentTextSize}/{TEXT_SIZE}
    </Typography.Text>
  );
}
